import { createContext } from "react"
import type { RealtimeContextType } from "./types"

export const RealtimeContext = createContext<RealtimeContextType | null>(null)
